import React from 'react';
import { SiteConfig } from '../types';
import { Github, Users, Mail, ShoppingBag } from 'lucide-react';
import { SpigotIcon } from './Hero';

interface FooterProps {
  config: SiteConfig;
}

export const Footer: React.FC<FooterProps> = ({ config }) => {
  return (
    <footer id="contact" className="bg-slate-950 py-12 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h3 className="text-white font-bold text-lg font-mono">Zivush<span className="text-mc-blue">Development</span></h3>
          <p className="text-slate-500 text-sm mt-2">Crafting code, block by block.</p>
        </div>
        
        <div className="flex flex-wrap gap-x-6 gap-y-3 items-center justify-center md:justify-end">
           {/* Socials Group */}
           <div className="flex items-center gap-4 pr-6 border-r border-slate-800">
             <a 
              href={config.discordInvite} 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-2 text-slate-400 hover:text-[#5865F2] transition-colors font-medium text-sm"
             >
               <Users className="w-4 h-4" />
               Discord
             </a>
             <a 
              href={config.githubUrl} 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors font-medium text-sm"
             >
               <Github className="w-4 h-4" />
               GitHub
             </a>
           </div>

           {/* Marketplaces & Contact Group */}
           <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href={config.spigotUrl || '#'} 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-2 text-slate-400 hover:text-[#ea9829] transition-colors text-sm font-medium"
            >
              <SpigotIcon className="w-4 h-4" />
              SpigotMC
            </a>
            <a 
              href={config.builtByBitUrl || '#'} 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm font-medium"
            >
              <ShoppingBag className="w-4 h-4" />
              BuiltByBit
            </a>
            <a 
              href={`mailto:${config.email}`} 
              className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm font-medium"
            >
              <Mail className="w-4 h-4" />
              Email
            </a>
           </div>
        </div>

        <div className="text-slate-600 text-xs select-none text-center md:text-right w-full md:w-auto">
          <span>&copy;</span> {new Date().getFullYear()} Zivush Development.<br/>Not affiliated with Mojang AB.
        </div>
      </div>
    </footer>
  );
};